<template>
  <div class="subscription-management">
    <el-card shadow="hover">
      <template slot="header">
        <div class="card-header">
          <span>随心订管理</span>
        </div>
      </template>
      <el-table :data="subscriptions" style="width: 100%">
        <el-table-column prop="_id" label="计划ID"></el-table-column>
        <el-table-column prop="user_id" label="用户ID"></el-table-column>
        <el-table-column prop="cycle_type" label="计划类型"></el-table-column>
        <el-table-column prop="start_date" label="开始日期"></el-table-column>
        <el-table-column prop="end_date" label="结束日期"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="viewSubscription(scope.row)">查看</el-button>
            <el-button size="small" @click="updateSubscription(scope.row)">更新</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionManagement',
  data() {
    return {
      subscriptions: []
    }
  },
  mounted() {
    this.getSubscriptions();
  },
  methods: {
    getSubscriptions() {
      this.subscriptions = [
        {
          _id: '1',
          user_id: '1',
          cycle_type: '周餐',
          start_date: '2026-03-15',
          end_date: '2026-03-22',
          status: '活跃',
          createdAt: '2026-03-15 10:00:00'
        },
        {
          _id: '2',
          user_id: '2',
          cycle_type: '月餐',
          start_date: '2026-03-14',
          end_date: '2026-04-14',
          status: '活跃',
          createdAt: '2026-03-14 18:20:00'
        },
        {
          _id: '3',
          user_id: '3',
          cycle_type: '周餐',
          start_date: '2026-03-13',
          end_date: '2026-03-20',
          status: '活跃',
          createdAt: '2026-03-13 10:15:00'
        },
        {
          _id: '4',
          user_id: '4',
          cycle_type: '月餐',
          start_date: '2026-02-12',
          end_date: '2026-03-12',
          status: '已结束',
          createdAt: '2026-02-12 14:45:00'
        }
      ];
    },
    getStatusType(status) {
      switch (status) {
        case '活跃': return 'success';
        case '已暂停': return 'warning';
        case '已结束': return 'info';
        case '待生效': return 'primary';
        case '已取消': return 'danger';
        default: return '';
      }
    },
    viewSubscription(subscription) {
      console.log('查看随心订:', subscription);
    },
    updateSubscription(subscription) {
      console.log('更新随心订:', subscription);
    }
  }
}
</script>

<style scoped>
.subscription-management {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>